import { Navigate } from "react-router-dom";
import { useModuleAccess } from "@/context/PermissionsContext";

// Protegge le route dei moduli riservati (amministrazione, contabilità).
export function RequireModule({ moduleKey, children }) {
  const { canAccess } = useModuleAccess();
  if (!canAccess(moduleKey)) return <Navigate to="/" replace />;
  return children;
}
